import { Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import ReturnToAppointmentMenuButton from '../ReturnToAppointment/ReturnToAppointmentMenuButton';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import EndCallButton from '../Buttons/EndCallButton/EndCallButton';
import Menu from '../MenuBar/Menu/Menu';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 12,
    background: 'rgba(20, 22, 24, 0.92)',
    backdropFilter: 'blur(6px)',
    paddingLeft: '0.75em',
    paddingRight: '0.5em',
    display: 'none',
    height: `${theme.mobileTopBarHeight}px`,
    boxSizing: 'border-box',
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  roomName: {
    color: '#fff',
    marginLeft: '0.25em',
  },
  endCallButton: {
    height: '28px',
    fontSize: '0.85rem',
    padding: '0 0.6em',
  },
  settingsButton: {
    [theme.breakpoints.down('sm')]: {
      height: '28px',
      minWidth: '28px',
      border: '1px solid rgb(136, 140, 142)',
      padding: 0,
      margin: '0 1em',
    },
  },
}));

export default function MobileTopMenuBar() {
  const classes = useStyles();
  const { room } = useVideoContext();

  return (
    <Grid container alignItems="center" justify="space-between" className={classes.container}>
      <Grid item container alignItems="center" style={{ flex: 1, minWidth: 0 }}>
        <ReturnToAppointmentMenuButton variant="in-call" />
        <Typography variant="subtitle1" noWrap className={classes.roomName}>
          {room!.name}
        </Typography>
      </Grid>
      <div>
        <EndCallButton className={classes.endCallButton} />
        <Menu buttonClassName={classes.settingsButton} />
      </div>
    </Grid>
  );
}
